import React from 'react';
import CommandOutput from './CommandOutput';
import ReadOnlyPrompt from './ReadOnlyPrompt';
import EditablePrompt from './EditablePrompt';

class CommandPrompt extends CommandOutput {
  constructor(controller, prompt, options) {
    super();
    this.controller = controller;
    this.title = prompt;
    this.options = options;
    this.value = options.default || '';
    this.promptResolver = null;
    this.saved = false;
  }

  waitForAnswer() {
    return new Promise(resolve => (this.promptResolver = resolve));
  }

  save() {
    this.saved = true;
    this.promptResolver(this.value);
    this.controller.actionPromptComplete();
  }

  render() {
    if (this.saved) return <ReadOnlyPrompt prompt={this} />;
    else return <EditablePrompt prompt={this} />;
  }
}

export default CommandPrompt;
